import {
  EmploymentPeriodStatusEnum,
  FokParameterChoice,
  MarkupNew,
  MarkupStatusEnum,
} from '@fora-monorepo/employer-my-pages-common/types';
import { getPreviousAndFutureMarkups } from '@fora-monorepo/employer-my-pages-common/utils';
import { Flex, ResponsiveSpacing } from '@foradevelopment/fora-ui';

import { getParameterTKeys } from '../../common/utils';
import { ParameterChoiceDateRangeItemDetail } from './ParameterChoiceDateRangeItemDetail';
import { MarkupDateRangeItemDetail } from './MarkupDateRangeItemDetail';

export const MarkupAndParametersList = ({
  markups,
  marginTop,
  fokParameters,
  employmentPeriodStatus,
}: {
  employmentPeriodStatus: EmploymentPeriodStatusEnum;
  fokParameters: FokParameterChoice[];
  markups: MarkupNew[];
  marginTop?: ResponsiveSpacing;
}) => {
  const { previousMarkups, futureMarkups } = getPreviousAndFutureMarkups(markups);
  const activeMarkup = markups.find(markup => markup.status === MarkupStatusEnum.Active);

  const isEmploymentPeriodActive = employmentPeriodStatus === EmploymentPeriodStatusEnum.Active;
  const hasOnlyActiveMarkups = activeMarkup && !futureMarkups.length && !previousMarkups.length;

  return (
    <Flex flexDirection="column" rowGap={30} marginTop={marginTop}>
      {isEmploymentPeriodActive && activeMarkup && (
        <MarkupDateRangeItemDetail
          employmentPeriodStatus={employmentPeriodStatus}
          markup={activeMarkup}
          markupStatus={MarkupStatusEnum.Active}
          hasOnlyActiveMarkups={hasOnlyActiveMarkups}
        />
      )}
      {futureMarkups.map((markup, index) => (
        <MarkupDateRangeItemDetail
          employmentPeriodStatus={employmentPeriodStatus}
          markup={markup}
          markupStatus={MarkupStatusEnum.Future}
          key={index}
        />
      ))}
      {previousMarkups.map((markup, index) => (
        <MarkupDateRangeItemDetail
          employmentPeriodStatus={employmentPeriodStatus}
          markup={markup}
          markupStatus={MarkupStatusEnum.Expired}
          key={index}
        />
      ))}

      {fokParameters?.map((fokParameterChoice: FokParameterChoice, index) => {
        const { name, description } = getParameterTKeys(fokParameterChoice.parameterValue);
        return (
          <ParameterChoiceDateRangeItemDetail
            key={index}
            name={name}
            description={description}
            fokParameterChoice={fokParameterChoice}
            showHeading={index === 0}
          />
        );
      })}
    </Flex>
  );
};
